import type { Transition, Variants } from 'motion/react'

/**
 * Motion vocabulary. Springs are tuned to feel like iOS: quick to respond,
 * settling without visible bounce (high damping), never longer than ~0.5s.
 */
export const spring = {
  /** Small UI: buttons, chips, highlights. */
  snappy: { type: 'spring', stiffness: 520, damping: 38, mass: 0.7 } satisfies Transition,
  /** Default for content entering or moving. */
  smooth: { type: 'spring', stiffness: 320, damping: 34, mass: 0.9 } satisfies Transition,
  /** Large surfaces: panels, the composer gliding to the bottom. */
  gentle: { type: 'spring', stiffness: 210, damping: 30, mass: 1 } satisfies Transition,
} as const

export const ease = {
  out: [0.22, 1, 0.36, 1] as const,
  apple: [0.32, 0.72, 0, 1] as const,
}

/**
 * Fade + rise, used for most entering content. A timed ease (not a spring) so text
 * lands exactly on whole pixels instead of creeping in sub-pixel steps, and no blur:
 * animating filters repaints every frame.
 */
export const riseIn: Variants = {
  // A transform string (not `y`) lets the browser run it as a native, compositor animation.
  hidden: { opacity: 0, transform: 'translateY(10px)' },
  show: { opacity: 1, transform: 'translateY(0px)', transition: { duration: 0.45, ease: ease.out } },
}

/** Parent that reveals children one after another. */
export const stagger = (gap = 0.05, delay = 0): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: gap, delayChildren: delay } },
})
